module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"play":"Play","tap-to-unmute":"Tap to Unmute"},"es":{"play":"Reproducir","tap-to-unmute":"Activar Sonido"},"pt":{"play":"Reproduzir","tap-to-unmute":"Toque para ativar som"}}')
  delete Component.options._Ctor
}
